import { AxiosInstance } from "axios";
import { buildClient } from "./axiosClient";

export const ElementsApi = (client: AxiosInstance = buildClient()) => {
  return {
    // #region ElementTree
    /**
     * Get an element tree as an embedded tree
     * @returns {Promise<AxiosResponse<any>>}
     */
    getElementTree: () => {
      return client
        .get(`/app/elements/UserApi/ElementTree`)
        .then((response) => response.data);
    },

    /**
     * Get an element tree as a flattened list
     * @returns {Promise<AxiosResponse<any>>}
     */
    getElementTreeList: () => {
      return client.get(`/app/elements/UserApi/ElementTree/List`);
    },

    /**
     * Get an equipment by groupId
     * @param {string} treeId treeId for equipment query
     * @returns {Promise<AxiosResponse<any>>}
     */
    getElementTreeByTreeId: (treeId) => {
      return client.get(`/app/elements/UserApi/ElementTree/Child/${treeId}`);
    },
    // #endregion
    // #region Equipment
    /**
     * Get all equipment
     * @params {string} [eventsId] optional filter on groupId
     * @params {?bool} deleted null: get all, true: get deleted, false: get active
     * @returns {Promise<AxiosResponse<Any>>}
     */
    getAllEquipment: (eventsId, deleted = null) => {
      const params = { deleted };
      if (eventsId) params["eventsId"] = eventsId;
      return client.get(`/app/elements/UserApi/Equipment`, {
        params: params,
      });
    },

    /**
     * Get equipment by equipmentId
     * @param {string} equipmentId
     * @returns {Promise<AxiosResponse<any>>}
     */
    getEquipmentById: (equipmentId) => {
      return client.get(`/app/elements/UserApi/Equipment/${equipmentId}`);
    },
    // #endregion
    // #region Events
    /**
     * Get all equipment groups
     * @params {?string} elementTreeId Optional filter by elementTree contains elementTreeId
     * @params {?bool} deleted null: get all, true: get deleted, false: get active
     * @returns {Promise<AxiosResponse<any>>}
     */
    getEventss: (elementTreeId, deleted = null) => {
      return client.get(`/app/elements/UserApi/Events`, {
        params: { elementTreeId, deleted },
      });
    },

    /**
     * Get equipment group by id
     * @param groupId
     * @returns {Promise<AxiosResponse<any>>}
     */
    getEventsById: (groupId) => {
      return client.get(`/app/elements/UserApi/Events/${groupId}`);
    },
    // #endregion
    // #region EventsUserApi
    /**
     * Create equipment group
     * @param {Equipment} equipmentData
     * @returns {Promise<AxiosResponse<any>>}
     */
    createEvents: (equipmentIds, equipmentData) => {
      const params = {};
      if (equipmentIds) {
        if (Array.isArray(equipmentIds)) {
          params["equipmentIds"] = equipmentIds.join(",");
        } else {
          params["equipmentIds"] = equipmentIds;
        }
      }

      return client.post(`/app/elements/UserApi/Events`, equipmentData, {
        params,
      });
    },

    /**
     * Create or edit equipment group
     * @param {string} equipmentId
     * @param {Events} equipmentData
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateEvents: (equipmentId, equipmentData) => {
      return client.put(
        `/app/elements/UserApi/Events/${equipmentId}`,
        equipmentData
      );
    },

    /**
     * Delete equipment group
     * @param {string} groupId equipment groupId
     * @returns {Promise<AxiosResponse<any>>}
     */
    deleteEvents: (groupId) => {
      return client.delete(`/app/elements/UserApi/Events/${groupId}`);
    },
    // #endregion
    // #region EquipmentUserApi
    /**
     * Create equipment
     * @param {Events} equipmentData
     * @returns {Promise<AxiosResponse<any>>}
     */
    createEquipment: (equipmentData) => {
      return client.post(`/app/elements/UserApi/Equipment`, equipmentData);
    },

    /**
     * Create or edit equipment
     * @param {string} equipmentId
     * @param {Events} equipmentData
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateEquipment: (equipmentId, equipmentData) => {
      return client.patch(
        `/app/elements/UserApi/Equipment/${equipmentId}`,
        equipmentData
      );
    },

    /**
     * Delete equipment
     * @param {string} equipmentId
     * @returns {Promise<AxiosResponse<any>>}
     */
    deleteEquipment: (equipmentId) => {
      return client.delete(`/app/elements/UserApi/Equipment/${equipmentId}`);
    },

    /**
     * Searches for a barcode across all kinds of objects in database.
     * Note: if barcode is also expected to be a partition key (like when searching for members) then setting passing useAsPartitionKey = true will optimize the search as it will be performed within one partition only.
     * @param barcode
     * @returns {Promise<AxiosResponse<any>>}
     */
    getByBarcode: (barcode) => {
      return client.get(`/app/elements/barcode/${barcode}`);
    },
    // #endregion

    getEventsRulesAndEquipment: (id) => {
      return client.get(
        `/app/elements/UserApi/ElementManager/Events/RulesAndEquipment/${id}`
      );
    },
  };
};

export default ElementsApi;
